import { csrfToken } from "utils/csrf-token"
import { SERVER_FORM_ERROR } from "../constants"

/* eslint-disable no-underscore-dangle */
export default class CommentVotesService {
  /**
   * Creates an instance of CommentVotesService.
   * @param {String} token
   * @memberof CommentVotesService
   */
  constructor(token) {
    this._token = token
  }

  /**
   * @param {Request} request
   * @returns {Promise<?{ code: number, success: Boolean, error: ?String }>}
   * @memberof CommentVotesService
   */
  // eslint-disable-next-line class-methods-use-this
  async _sendRequest(request) {
    const response = await fetch(request)

    if (response.ok || response.status === 422) {
      try {
        const responseAsJson = await response.json()

        if (
          Object.hasOwnProperty.call(responseAsJson, "success") &&
          responseAsJson.success === true
        ) {
          return {
            code: response.status,
            success: true,
            error: null,
          }
        }

        if (Object.hasOwnProperty.call(responseAsJson, SERVER_FORM_ERROR)) {
          return {
            code: response.status,
            success: false,
            error: responseAsJson[SERVER_FORM_ERROR],
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)

        const responseAsText = await response.text()
        return {
          code: response.status,
          success: false,
          error: `Failed parsing JSON: ${responseAsText}`,
        }
      }
    } else {
      // eslint-disable-next-line no-console
      console.error(`${response.status}: ${response.statusText}`)

      return {
        code: response.status,
        success: false,
        error: `${response.status}: ${response.statusText}`,
      }
    }

    return null
  }

  /**
   * @param {Number} commentId
   * @param {Number} rating enumlike either -1 either 1
   * @memberof CommentVotesService
   */
  async vote(commentId, rating) {
    const request = new Request(`/comments/${commentId}/comment_vote`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken() || this._token,
      },
      body: JSON.stringify({
        comment_vote: {
          rating,
        },
      }),
    })

    return this._sendRequest(request)
  }

  /**
   * @param {Number} commentId
   * @param {Number} rating enumlike either -1 either 1
   * @memberof CommentVotesService
   */
  async undo(commentId, rating) {
    const request = new Request(`/comments/${commentId}/comment_vote`, {
      method: "DELETE",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken() || this._token,
      },
      body: JSON.stringify({
        comment_vote: {
          rating,
        },
      }),
    })

    return this._sendRequest(request)
  }
}
